import { createGlobalStyle } from "styled-components";
import normalize from "styled-normalize";
import { breakpoints } from "@theme/breakpoints";

export const GlobalStyles = createGlobalStyle`
  ${normalize};
  
  
  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    
    &:focus-visible {
      outline: 1px dashed ${({ theme }) => theme.washMedium};
    }
  }

  :root {
    interpolate-size: allow-keywords;
  }
  
  html {
    font-size: 10px;
  }
  
  body {
    font-size: 1.6rem;
    font-family: "Open Sans", "Helvetica Neue", "Roboto", sans-serif;
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.foreground};
    transition: color .2s ease-in-out, background .2s ease-in-out;
    
    &.is-loading {
      width: 100%;
      height: 100vh;
      overflow: hidden;
    }
  }

  h1 {
    font-size: 6.4rem;
    font-weight: 700;
    line-height: 1.4;
    font-family: "Noto Sans", "Open Sans", "Helvetica Neue", "Roboto", sans-serif;

    .is-colorized {
      color: ${({ theme }) => theme.primary};
    }
    
    ${breakpoints.laptopMax`
      font-size: 4.8rem;
    `}
    
    ${breakpoints.phoneMax`
      font-size: 2.6rem;
    `}
  }

  .pswp {
    z-index: 2147483647!important;
    position: fixed!important;
  }
`;
